(function () {

  'use strict';

  function pxSnmpForms($rootScope) {
    return {
      restrict: 'EA',
      scope: {
        formData: '=formData',
        callback: '&callback'
      },
      templateUrl: 'app/directives/snmpFormsDirective/snmp-forms.template.html',
      link: function (scope) {
        scope.snmpConfiguration = scope.formData.snmpConfiguration;
        scope.snmpConfigurationOriginal = scope.formData.snmpConfigurationOriginal;
        scope.authenticationLevel = null;
        scope.authentication = null;
        scope.privacy = null;
        scope.version = angular.copy(scope.snmpConfiguration.info.version);
        scope.selectedNetworks = scope.formData.selectedNetworks;
        scope.availableNetworks = scope.formData.availableNetworks;

        (function () {
          setSelectedItem();
        })();

        function setSelectedItem() {
          scope.authenticationLevel = {
            listRaw: [
              { name: 'NOAUTHNOPRIV', id: 'NOAUTHNOPRIV' },
              { name: 'AUTHNOPRIV', id: 'AUTHNOPRIV' },
              { name: 'AUTHPRIV', id: 'AUTHPRIV' }
            ],
            placeholderText: 'Select',
            skipOrderByName: true
          };
          scope.authenticationLevel.selectedItem = getCurrentSelectedItem('authenticationLevel');

          scope.authentication = {
            listRaw: [
              { name: 'SHA 256',        id: 'SHA256', snmp_secure: 'secure'   },
              { name: 'SHA 384',        id: 'SHA384', snmp_secure: 'secure'   },
              { name: 'SHA 512',        id: 'SHA512', snmp_secure: 'secure'   },
              { name: 'SHA (unsecure)', id: 'SHA',    snmp_secure: 'unsecure' },
              { name: 'MD5 (unsecure)', id: 'MD5',    snmp_secure: 'unsecure' }
            ],
            placeholderText: 'Select',
            skipOrderByName: true
          };
          scope.authentication.selectedItem = getCurrentSelectedItem('authentication');

          scope.privacy = {
            listRaw: [
              { name: 'AES',            id: 'AES',    snmp_secure: 'secure'   },
              { name: 'AES 192',        id: 'AES192', snmp_secure: 'secure'   },
              { name: 'AES 256',        id: 'AES256', snmp_secure: 'secure'   },
              { name: 'DES (unsecure)', id: 'DES',    snmp_secure: 'unsecure' }
            ],
            placeholderText: 'Select',
            skipOrderByName: true
          };
          scope.privacy.selectedItem = getCurrentSelectedItem('privacy');
        }

        function getCurrentSelectedItem(context) {
          return scope[context].listRaw.find(item => item.id === scope.snmpConfiguration.info[context]) || null;
        }

        function isNetworksFieldValid() {
          return !!($rootScope.currentUser.permissions.TENANT_ADMIN || scope.snmpConfiguration.info.networkIds?.length);
        }

        scope.validateSnmpForm = function () {
          if (scope.snmpConfiguration.info.version === 'V1') {
            scope.callback({ item: scope.snmpConfiguration, boolean: scope.validateSnmpV1Form() });
          } else {
            scope.callback({ item: scope.snmpConfiguration, boolean: scope.validateSnmpV3Form() });
          }
        };

        scope.validateSnmpV1Form = function () {
          return !!(scope.snmpConfiguration.info.name && scope.snmpConfiguration.info.name.length <= 255 &&
            scope.snmpConfiguration.info.communityName && isNetworksFieldValid());
        };

        scope.validateSnmpV3Form = function () {
          if (!scope.snmpConfiguration.info.name || scope.snmpConfiguration.info.name.length > 255 ||
            !scope.snmpConfiguration.info.user || !scope.snmpConfiguration.info.authenticationLevel || !isNetworksFieldValid()) {
            return false;
          }

          switch (scope.snmpConfiguration.info.authenticationLevel) {
            case 'AUTHPRIV':
              if (!scope.snmpConfiguration.info.privacy || !scope.snmpConfiguration.info.privacyPhrase) {
                return false;
              }
              // falls through
            case 'AUTHNOPRIV':
              if (!scope.snmpConfiguration.info.authentication || !scope.snmpConfiguration.info.authPhrase) {
                return false;
              }
              // falls through
            case 'NOAUTHNOPRIV':
              return true;
          }

          return false;
        };

        scope.selectSnmpSecurytLevelType = function (item) {
          scope.snmpConfiguration.info.authenticationLevel = item.id;
        };

        scope.selectAuthenticationType = function (item) {
          scope.snmpConfiguration.info.authentication = item.id;
        };

        scope.selectPrivacyType = function (item) {
          scope.snmpConfiguration.info.privacy = item.id;
        };

        scope.changeVersion = function (version) {
          scope.snmpConfiguration = angular.copy(scope.snmpConfigurationOriginal);
          scope.snmpConfiguration.info.version = version;
        };

        scope.openNetworkSelector = function () {
          scope.networkSelectorIsOpen = true;
        };

        scope.closeNetworkSelector = function () {
          scope.networkSelectorIsOpen = false;
        };

        scope.onApplyNetworkSelection = function (selectedNetworks) {
          if (selectedNetworks && selectedNetworks.length) {
            scope.snmpConfiguration.info.networkIds = selectedNetworks.map(sn => sn.id);
            scope.selectedNetworks = angular.copy(selectedNetworks);
          } else {
            scope.snmpConfiguration.info.networkIds = [];
            scope.selectedNetworks = [];
          }
          scope.closeNetworkSelector();
        };

        scope.onCancelNetworkSelection = function () {
          scope.closeNetworkSelector();
        };

        scope.$watch(function () {
          return scope.snmpConfiguration.info;
        }, function () {
          scope.validateSnmpForm();
        }, true);
      }
    };
  }

  pxSnmpForms.$inject = ['$rootScope'];

  angular
    .module('printix-admin')
    .directive('pxSnmpForms', pxSnmpForms);

})();
